import type { MouseEvent } from "react";

import { FormattedMessage } from "react-intl";

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@ps-design-system/components/Nav";

import { NAV_LINKS } from "./HostHubNavigation.consts";
import type { HostHubNavigationProps } from "./HostHubNavigation.types";

const HostHubNavigation = ({
  activeTabId,
  onActiveTabIdChange,
}: HostHubNavigationProps) => {
  return (
    <div className="tw-w-full tw-border-b tw-border-gray-400 tw-bg-brand-white lg:tw-border-b-0">
      <div className="tw-box-border tw-w-full tw-max-w-[1440px] tw-pr-[24px]">
        <NavigationMenu
          className="tw-pl-[16px] lg:tw-pl-[160px]"
          layout="tabStrip"
          variant="white"
        >
          <NavigationMenuList className="tw-mb-0">
            {NAV_LINKS.map((link) => {
              return (
                <NavigationMenuItem
                  className="tw-flex tw-items-center"
                  key={link.id}
                >
                  <NavigationMenuLink
                    href={link.href}
                    onClick={(event: MouseEvent<HTMLAnchorElement>) => {
                      event.preventDefault();
                      onActiveTabIdChange(link.id);
                    }}
                    selected={activeTabId === link.id}
                  >
                    <FormattedMessage {...link.title} />
                  </NavigationMenuLink>
                </NavigationMenuItem>
              );
            })}
          </NavigationMenuList>
        </NavigationMenu>
      </div>
    </div>
  );
};

export default HostHubNavigation;
